var _desc, _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPinkAlert = function SvgPinkAlert(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M10,0 C12.7634799,0 15.1209895,0.978080986 17.0725995,2.9342723 C19.0242096,4.89046362 20,7.24568263 20,10 C20,12.7543174 19.0242096,15.1095364 17.0725995,17.0657277 C15.1209895,19.021919 12.7634799,20 10,20 C7.23652014,20 4.87901054,19.021919 2.92740047,17.0657277 C0.975790398,15.1095364 0,12.7543174 0,10 C0,7.24568263 0.967984075,4.89828826 2.90398126,2.95774648 C4.87120422,0.985905634 7.23652014,0 10,0 Z M10,2 C7.79471038,2 5.91007625,2.7797193 4.34604106,4.33918129 C2.78200587,5.89864327 2,7.78556398 2,10 C2,12.214436 2.78200587,14.1013567 4.34604106,15.6608187 C5.91007625,17.2202807 7.79471038,18 10,18 C12.2052896,18 14.0899238,17.2202807 15.6539589,15.6608187 C17.2179941,14.1013567 18,12.214436 18,10 C18,7.78556398 17.2179941,5.89864327 15.6539589,4.33918129 C14.0899238,2.7797193 12.2052896,2 10,2 Z M10.9929742,9.01408451 L10.9929742,15.0140845 L8.99297424,15.0140845 L8.99297424,9.01408451 L10.9929742,9.01408451 Z M10.9929742,4.97652582 L10.9929742,6.97652582 L8.99297424,6.97652582 L8.99297424,4.97652582 L10.9929742,4.97652582 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "01-Waiting-room",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.8-Waiting-room-/-Rejoin-call",
    transform: "translate(-260.000000, -142.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Error-/-Circle-/-Filled",
    transform: "translate(260.000000, 142.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ic_info_circle_outline",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Color",
    mask: "url(#mask-2)",
    fill: "#AD5E99"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uD83C\\uDFA8-Color",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  })))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPinkAlert, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pink-alert.fddfc354.svg";
export { ForwardRef as ReactComponent };